import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Button } from 'components/shared/Button/Button'
import { Form } from 'components/shared/Form/Form'

import {
  CATEGORY_TITLE_FIELD,
  SCOREABLE_FIELD,
} from './../../../../../../model'

import styles from './CategoryFieldsGroup.module.scss'

export const CategoryFieldsGroup = ({
  control,
  formState,
  onDeleteCategoryOpen,
  watch,
  isCategoryScorable,
  isCategoryDeletable,
  isStaticPage,
}) => (
  <Box align="center" className={styles.group} justify="space-between">
    <Form.Field
      className={styles.category}
      count={watch(CATEGORY_TITLE_FIELD)?.length}
      error={formState.errors[CATEGORY_TITLE_FIELD]?.message}
      field="input"
      label={t`Category title`}
      limit={30}
      name={CATEGORY_TITLE_FIELD}
      placeholder={t`Add a title to this category`}
      {...{ control }}
    />
    <Form.Field
      className={styles.switch}
      field="switch"
      label={t`Score this category`}
      name={SCOREABLE_FIELD}
      isDisabled={isStaticPage || !isCategoryScorable}
      {...{ control }}
    />
    <Button
      className={styles.button}
      label={t`Remove category`}
      size="medium"
      variant="outlined"
      onClick={onDeleteCategoryOpen}
      isDisabled={!isCategoryDeletable}
    />
  </Box>
)
